/*
 *
 * Collaborators constants
 *
 */
export const HAS_COLLABORATORS_WATCHER =
  "app/Collaborators/HAS_COLLABORATORS_WATCHER"
export const HAS_COLLABORATORS_SUCCESS =
  "app/Collaborators/HAS_COLLABORATORS_SUCCESS"
export const HAS_COLLABORATORS_FAILED =
  "app/Collaborators/HAS_COLLABORATORS_FAILED"

export const HAS_SEGMENTS_WATCHER = "app/Collaborators/HAS_SEGMENTS_WATCHER"
export const HAS_SEGMENTS_SUCCESS = "app/Collaborators/HAS_SEGMENTS_SUCCESS"
export const HAS_SEGMENTS_FAILED = "app/Collaborators/HAS_SEGMENTS_FAILED"

export const HAS_DIVISIONS_WATCHER = "app/Collaborators/HAS_DIVISIONS_WATCHER"
export const HAS_DIVISIONS_SUCCESS = "app/Collaborators/HAS_DIVISIONS_SUCCESS"
export const HAS_DIVISIONS_FAILED = "app/Collaborators/HAS_DIVISIONS_FAILED"

export const GET_TEMPLATE_COLLABORATORS_WATCHER =
  "app/Collaborators/GET_TEMPLATE_COLLABORATORS_WATCHER"
export const GET_TEMPLATE_COLLABORATORS_SUCCESS =
  "app/Collaborators/GET_TEMPLATE_COLLABORATORS_SUCCESS"
export const GET_TEMPLATE_COLLABORATORS_FAILED =
  "app/Collaborators/GET_TEMPLATE_COLLABORATORS_FAILED"

export const UPLOAD_TEMPLATE_COLLABORATORS_WATCHER =
  "app/Collaborators/UPLOAD_TEMPLATE_COLLABORATORS_WATCHER"
export const UPLOAD_TEMPLATE_COLLABORATORS_SUCCESS =
  "app/Collaborators/UPLOAD_TEMPLATE_COLLABORATORS_SUCCESS"
export const UPLOAD_TEMPLATE_COLLABORATORS_FAILED =
  "app/Collaborators/UPLOAD_TEMPLATE_COLLABORATORS_FAILED"

export const GET_COLLABORATORS_WATCHER =
  "app/Collaborators/GET_COLLABORATORS_WATCHER"
export const GET_COLLABORATORS_SUCCESS =
  "app/Collaborators/GET_COLLABORATORS_SUCCESS"
export const GET_COLLABORATORS_FAILED =
  "app/Collaborators/GET_COLLABORATORS_FAILED"

export const SEARCH_COLLABORATORS_WATCHER =
  "app/Collaborators/SEARCH_COLLABORATORS_WATCHER"
export const SEARCH_COLLABORATORS_SUCCESS =
  "app/Collaborators/SEARCH_COLLABORATORS_SUCCESS"
export const SEARCH_COLLABORATORS_FAILED =
  "app/Collaborators/SEARCH_COLLABORATORS_FAILED"

export const GET_TEAM_WATCHER = "app/Collaborators/GET_TEAM_WATCHER"
export const GET_TEAM_SUCCESS = "app/Collaborators/GET_TEAM_SUCCESS"
export const GET_TEAM_FAILED = "app/Collaborators/GET_TEAM_FAILED"

export const ASSIGN_LEADER_WATCHER = "app/Collaborators/ASSIGN_LEADER_WATCHER"
export const ASSIGN_LEADER_SUCCESS = "app/Collaborators/ASSIGN_LEADER_SUCCESS"
export const ASSIGN_LEADER_FAILED = "app/Collaborators/ASSIGN_LEADER_FAILED"

export const GET_POTENTIAL_LEADERS_WATCHER =
  "app/Collaborators/GET_POTENTIAL_LEADERS_WATCHER"
export const GET_POTENTIAL_LEADERS_SUCCESS =
  "app/Collaborators/GET_POTENTIAL_LEADERS_SUCCESS"
export const GET_POTENTIAL_LEADERS_FAILED =
  "app/Collaborators/GET_POTENTIAL_LEADERS_FAILED"

export const GET_VISMA_PEOPLE_STATUS_WATCHER =  "app/Collaborators/GET_VISMA_PEOPLE_STATUS_WATCHER"
export const GET_VISMA_PEOPLE_STATUS_SUCCESS =  "app/Collaborators/GET_VISMA_PEOPLE_STATUS_SUCCESS"
export const GET_VISMA_PEOPLE_STATUS_FAILED =  "app/Collaborators/GET_VISMA_PEOPLE_STATUS_FAILED"

export const GET_TEAM_POTENTIAL_WATCHER =
  "app/Collaborators/GET_TEAM_POTENTIAL_WATCHER"
export const GET_TEAM_POTENTIAL_SUCCESS =
  "app/Collaborators/GET_TEAM_POTENTIAL_SUCCESS"
export const GET_TEAM_POTENTIAL_FAILED =
  "app/Collaborators/GET_TEAM_POTENTIAL_FAILED"

export const ADD_EMPLOYEES_TEAM_WATCHER =
  "app/Collaborators/ADD_EMPLOYEES_TEAM_WATCHER"
export const ADD_EMPLOYEES_TEAM_SUCCESS =
  "app/Collaborators/ADD_EMPLOYEES_TEAM_SUCCESS"
export const ADD_EMPLOYEES_TEAM_FAILED =
  "app/Collaborators/ADD_EMPLOYEES_TEAM_FAILED"

export const REMOVE_EMPLOYEES_TEAM_WATCHER =
  "app/Collaborators/REMOVE_EMPLOYEES_TEAM_WATCHER"
export const REMOVE_EMPLOYEES_TEAM_SUCCESS =
  "app/Collaborators/REMOVE_EMPLOYEES_TEAM_SUCCESS"
export const REMOVE_EMPLOYEES_TEAM_FAILED =
  "app/Collaborators/REMOVE_EMPLOYEES_TEAM_FAILED"

export const REMOVE_COLLABORATORS_WATCHER =
  "app/Collaborators/REMOVE_COLLABORATORS_WATCHER"
export const REMOVE_COLLABORATORS_SUCCESS =
  "app/Collaborators/REMOVE_COLLABORATORS_SUCCESS"
export const REMOVE_COLLABORATORS_FAILED =
  "app/Collaborators/REMOVE_COLLABORATORS_FAILED"

export const GET_MEASURES_WATCHER = "app/Collaborators/GET_MEASURES_WATCHER"
export const GET_MEASURES_SUCCESS = "app/Collaborators/GET_MEASURES_SUCCESS"
export const GET_MEASURES_FAILED = "app/Collaborators/GET_MEASURES_FAILED"
